// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function elSalvadorOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'sv',
    document: userInputValues['elSalvadorDocument'],
    zipcode: userInputValues['elSalvadorZipcode'],
    state: userInputValues['elSalvadorState'],
    city: userInputValues['elSalvadorCity'],
    address: userInputValues['elSalvadorAddress'],
    street_number: userInputValues['elSalvadorStreetNumber'],
    street_complement: userInputValues['elSalvadorStreetComplement'],
    phone_number: userInputValues['elSalvadorPhoneNumber'],
  };
}
